module.exports = __webpack_public_path__ + "img/italy-endocrine-nutritional-metabolic-diseases-male.ee9c5dfe.png";